import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnChanges, OnInit {
  @Input() public loading: boolean;
  @Input() public full: boolean;
  @Input() public size: string;

  messages = [];
  timer: any;
  message = '';
  init = 0;
  time = 1200;
  times = 0;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.translate
      .get([
        'loading.text-1',
        'loading.text-2',
        'loading.text-3',
        'loading.text-4',
        'loading.text-5'
      ])
      .subscribe((values) => {
        this.messages = Object.keys(values).map((key) => values[key]);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.loading) {
      this.random();
    } else {
      this.init = 0;
      clearInterval(this.timer);
    }
  }

  random() {
    const myFunction = () => {
      this.changeMessage();
      const rand = Math.round(Math.random() * (3500 - 800)) + 800;
      this.timer = setTimeout(myFunction, rand);
    };
    myFunction();
  }

  changeMessage() {
    const stop = this.messages.length - 1;
    this.times += 1;
    this.message = this.messages[this.init];
    this.init = this.init === stop ? stop : this.init + 1;
  }
}
